import { useDispatch } from "react-redux";
import classNames from "classnames";
import { logout } from "../../../../../redux/auth";
import { clearAuthToken } from "../../../../../helpers/auth";
import logoutIcon from "../../../../../assets/icons/logout.svg";
import classes from "./Logout.module.css";

const Logout = (props) => {
  const { className } = props;
  const dispatch = useDispatch();
  const logoutClickedHandler = () => {
    clearAuthToken();
    dispatch(logout());
  };

  return (
    <button
      className={classNames(classes["logout"], className)}
      onClick={logoutClickedHandler}
    >
      <img src={logoutIcon} alt="logout" />
      تسجيل الخروج
    </button>
  );
};

export default Logout;
